import { INITIALS_LENGTH } from "./constants";
var trimInitials = function trimInitials(initials) {
  return initials.substr(0, INITIALS_LENGTH);
};

// eslint-disable-next-line import/prefer-default-export
export var formatInitials = function formatInitials(initials) {
  return trimInitials(initials).toUpperCase();
};